export default {"src":"/_next/static/media/guest.255ab868.svg","height":259,"width":208,"blurWidth":0,"blurHeight":0};